<template name="alertModal">
    <div class="common-modal" v-show="isModalShown" @click="closeModal($event)">
        <div class="confirm-wrapper">
        <div class="confirm-header" :class="{ 'none-function': modalType === 'none-function' }">
            {{ modalTitle }}
        </div>
        <div class="confirm-btn" @click="handleCancel" v-if="modalType === 'simple'">
            {{$t('confirm')}}
        </div>
        <div class="confirm-btn row" v-if="modalType === undefined || modalType === 'normal'">
            <div class="col-6" @click="handleCancel">{{ cancelBtnName ? cancelBtnName : $t('Cancel') }}</div>
            <div class="col-6 confrim" @click="handleConfirm">{{ confirmBtnName ? confirmBtnName : $t('confirm') }}</div>
        </div>
        <div class="confirm-btn" v-if="modalType === 'skipNotice'" @click="handleConfirm">
            <span>{{ confirmBtnName !== '' ? confirmBtnName : $t('confirm') }}</span>
        </div>
        </div>
    </div>
</template>

<script type="text/javascript">
/**
 * Bind isModalShown, modalTitle, cancel / confirm callback, if you dont need confirm btn, bind modalType="simple"
 * Basic usage:
 * <alertModal :isModalShown="isDeleteModalShow" modalTitle="确认删除" @cancel="isDeleteModalShow = false" @confirm="deleteVisitor"></alertModal>
 */
export default {
  name: 'alertModal',
  components: {
  },
  data() {
    return {
    };
  },
  props: {
    isModalShown: Boolean,
    modalType: String,
    modalTitle: String,
    cancelBtnName: String,
    confirmBtnName: String,
  },
  mounted() {
    if (this.$props.isModalShown) {
      document.body.classList.add('modal-open');
    }
  },
  watch: {
    isModalShown() {
      document.body.classList.toggle('modal-open');
    },
    $route() {
      document.body.classList.remove('modal-open');
    },
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
    },
    handleConfirm() {
      this.$emit('confirm');
    },
    closeModal(e) {
      this.$emit('closeModal', e);
    }
  },
};
</script>
<style scoped lang="scss">
  @import '../scss/variables.scss';
  .common-modal {
    height: 100vh;
    background: rgba(0,0,0,.4);
    z-index: 2000;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    position: fixed;
    .confirm-wrapper {
      background: #fcfcfc;
      width: 72%;
      border-radius: 12px;
      font-size: 17px;
      text-align: center;
      @include respond-to('sm') {
        width: 414px;
      }
      .confirm-header {
        padding: 34.5px 1em 20px;
        border-bottom: 1px solid #f0f1f2;
        &.none-function {
          border-bottom: none;
          padding-bottom: 34.5px;
        }
      }
      .confirm-btn {
        height: 40px;
        line-height: 40px;
        color: #e42029;
        & > div:first-child {
          border-right: 1px solid #f0f1f2;
          font-size: 17px;
          color: #4a4a4a;
        }
      }
    }
  }
</style>
